/* ==========================================================================
   HEATHER'S HEXES - MASTER JAVASCRIPT ENGINE
   Wizard Customizer, Grimoire Plates Modal, Live Scroll & Shopify Cart AJAX
   ========================================================================== */

(function () {
  'use strict';

  /* ---------- Mock & Shopify Cart State ---------- */
  window.hhCartItems = window.hhCartItems || [];

  function hhFetchCartCount() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        hhSetCartCount(cart.item_count);
      })
      .catch(() => {
        // Fallback to local array length if running standalone
        const total = window.hhCartItems.reduce((acc, it) => acc + (it.quantity || 1), 0);
        hhSetCartCount(total);
      });
  }

  function hhSetCartCount(count) {
    const els = document.querySelectorAll('.hh-cart-count, #hhCount');
    els.forEach(el => {
      el.textContent = count;
    });
  }

  window.hhViewCart = function (e) {
    if (e) e.preventDefault();
    // If Minimog or standard cart drawer exists, trigger it
    const cartDrawerBtn = document.querySelector('[data-cart-drawer-trigger], .cart-drawer-toggle, [data-open-cart-drawer], .header__cart');
    if (cartDrawerBtn && typeof cartDrawerBtn.click === 'function') {
      cartDrawerBtn.click();
      return;
    }
    // Fallback toast & direct link
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        if (cart.item_count === 0 && window.hhCartItems.length === 0) {
          hhToast("✦ Your cart is empty. Cast a hex or choose a grimoire plate.");
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(() => {
        if (window.hhCartItems.length === 0) {
          hhToast("✦ Your cart is empty. Cast a hex or choose a grimoire plate.");
        } else {
          const names = window.hhCartItems.map(i => `${i.title} (${i.price})`).join('\n• ');
          hhToast(`✦ Cart contains (${window.hhCartItems.length} items):\n• ${names}`);
        }
      });
  };

  /* ---------- Witches & Grimoire Plates Data ---------- */
  const SEVEN = [
    {
      rn: "I",
      name: "Anselm Vogt",
      place: "Freiburg · Germany",
      ward: "The Green Watch of the Black Forest",
      em: '<g fill="none" stroke="url(#gold)" stroke-width="3" stroke-linejoin="round" stroke-linecap="round"><path d="M50 24 L60 42 H40 Z"/><path d="M50 37 L65 60 H35 Z"/><path d="M50 52 L70 80 H30 Z"/><path d="M50 80 V90"/></g>',
      lore: "<em>Anselm breaks curses, keeps the devil from your door, and calls the storm when it's needed.</em> His power begins with his Zauberbuch, a family book kept in absolute secrecy and said to refuse the fire. The Sixth and Seventh Books of Moses taught him the seals that summon planetary angels and bend the elements; the Black Raven taught him to break a curse; The Long Lost Friend gave him the old Braucherei charms that guard a home. In the Black Forest he draws sickness into trees, binds curses into knotted cords, and, as a Wettermacher, calls wind, hail and lightning."
    },
    {
      rn: "II",
      name: "Fiona MacBride",
      place: "Scottish Highlands",
      ward: "Keeper of the Standing Stones",
      em: '<g fill="none" stroke="url(#gold)" stroke-width="3" stroke-linecap="round"><path d="M50 24 C36 40 36 62 50 84 C64 62 64 40 50 24 Z"/><path d="M50 30 V80"/><path d="M50 46 L41 40 M50 54 L59 48 M50 62 L42 57"/></g>',
      lore: "<em>Fiona survived the hardest country there is. Her spell is strength, resilience, healing and protection.</em> Heir to the Highland cunning folk, she was taught by word of mouth rather than from grimoires. She works the eòlas and the rann, old charms spoken in rhythm, and keeps her worn Carmina Gadelica close. She guards the goodness of field and herd, trusts the rowan above all protections, and can send her spirit across the moors in the shape of a hare. With the Second Sight she reads what's coming in birds, clouds and the ache of granite before a storm."
    },
    {
      rn: "III",
      name: "Rowan Ellison",
      place: "Salem · Massachusetts",
      ward: "Keeper of the Wary Flame",
      em: '<g><rect x="41" y="52" width="18" height="34" rx="2" fill="none" stroke="url(#gold)" stroke-width="3"/><path d="M50 46 V52" stroke="url(#gold)" stroke-width="3"/><path d="M50 30 C43 39 46 48 50 48 C54 48 57 39 50 30 Z" fill="url(#gold)"/></g>',
      lore: "<em>Rowan feels the truth in her fingertips, and uses her spirit and her healing to show you the way.</em> Born into the craft in Salem, she practises witchcraft as an intuitive science: trance, meditation, herbalism and spellcraft, every day. She reaches back through Gardner and Leland to the roots of Wicca, and into Solomonic talismans and Agrippa's ceremonial magic. Each autumn, when Salem's veil runs thin, she leads séances and works with the ancestors. She reads the way a flame leans and gutters, and keeps a window lit for anyone looking for the door in the dark."
    },
    {
      rn: "IV",
      name: "Nuria Castro",
      place: "Galicia · Spain",
      ward: "Fire-Witch of the Atlantic Coast",
      em: '<g fill="none" stroke="url(#gold)" stroke-width="3" stroke-linecap="round"><path d="M50 24 C39 44 45 58 50 82 C55 58 61 44 50 24 Z"/><path d="M50 46 C46 56 48 68 50 76"/></g>',
      lore: "<em>Nuria is fire. She drives off what haunts you, then sits beside you to read the moon and stars.</em> A meiga in the truest Galician sense, she learned from the Book of Saint Cyprian to cast out and bind malicious spirits and to make talismans and protective prayers. She cures the meigallo and the evil eye, gathers the herbs of San Xoán each midsummer, and knows where the encantos hide their treasure. She brews the queimada and speaks the conxuro over its blue flame. Fishermen come to her before a hard crossing, and the grieving come after."
    },
    {
      rn: "V",
      name: "Daciana Petran",
      place: "Bucharest · Romania",
      ward: "Stormcaller of Wallachia",
      em: '<g><rect x="34" y="38" width="22" height="32" rx="2" transform="rotate(-13 50 54)" fill="#1a1d3a" stroke="url(#gold)" stroke-width="3"/><rect x="45" y="38" width="22" height="32" rx="2" transform="rotate(11 50 54)" fill="#1a1d3a" stroke="url(#gold)" stroke-width="3"/></g>',
      lore: "<em>Daciana speaks, and it thunders. Cunning and fearless, she commands beasts, storms and the Fates themselves.</em> A vrăjitoare of Bucharest, she speaks the descântece, incantations passed from elder women to younger under strict taboo, to lift the evil eye and undo malevolent magic. She reads thunder and earthquakes in the old Gromovnic and knows the legends of the Solomonari, who rode dragons through the storm. She works her strongest spells at the Witches' Pond on Sânziene and Saint Andrew's Eve, and in her lamplit parlour she reads cards, coffee grounds and molten lead."
    },
    {
      rn: "VI",
      name: "Elias Mercado",
      place: "Siquijor · Philippines",
      ward: "Mananambal of the Healing Isle",
      em: '<g fill="none" stroke="url(#gold)" stroke-width="3" stroke-linecap="round"><path d="M50 86 V50"/><path d="M50 62 C40 60 33 52 33 44 C43 44 50 51 50 60 Z"/><path d="M50 56 C60 54 67 47 67 39 C57 39 50 46 50 54 Z"/><circle cx="50" cy="44" r="3" fill="url(#gold)"/></g>',
      lore: "<em>Elias is a keeper of stories and a translator of hearts. He heals with bark and oil, and he will pray and chant for you.</em> He carries a librito, the handwritten notebook of diagrams and prayers passed from mentor to apprentice. His oraciones, prayed in Latin, Spanish and Visayan, charge water, draw out venom and turn harmful magic back on whoever sent it. Each Holy Week he gathers roots, barks and resins for his healing oils, and he reads a patient's trouble in the clouding water of the bolo-bolo glass. His work is as much reassurance as remedy, and he counts that no failing."
    },
    {
      rn: "VII",
      name: "Thabo Nkosi",
      place: "KwaZulu-Natal · South Africa",
      ward: "Diviner of the Green Hills",
      em: '<g fill="none" stroke="url(#gold)" stroke-width="3" stroke-linecap="round"><path d="M32 50 C32 34 52 34 52 50 C52 66 72 66 72 50 C72 34 52 34 52 50 C52 66 32 66 32 50 Z"/></g>',
      lore: "<em>Thabo speaks to you in dreams. He hears the whisper of evil, and he keeps it from you.</em> He answered the call of intwaso, the summons that comes through dreams, and trained under a master healer. Guided by the amadlozi, the ancestors, he learned to interpret dreams, enter trance and read the bones, and he knows umuthi, the bark, root and mineral medicines that balance body and spirit. He has studied the whispered arts of harm, never to practise them but to recognise and undo them. His counsel is practical, and his silences are long."
    },
    {
      rn: "VIII",
      name: "Maryam Al-Kathiri",
      place: "Bahla · Oman",
      ward: "Letter-Keeper of the City of Jinn",
      em: '<g fill="none" stroke="url(#gold)" stroke-width="3"><rect x="30" y="30" width="40" height="40"/><path d="M43.3 30 V70 M56.7 30 V70 M30 43.3 H70 M30 56.7 H70"/></g>',
      lore: "<em>Maryam learned from the masters. Her incantations can change the course of a life. She knows your name.</em> She grew up in the shadow of Bahla Fort, heir to the region's own hidden sciences. Her deepest learning comes from unbound folios passed from master to apprentice. She brews talismanic inks of saffron and rosewater, turns a name into its hidden number and seals it to heal, conceal or shield, and through long fasts has bound jinn to her service. In town she passes for a folk healer, and few who come to her know what she can really do."
    },
    {
      rn: "IX",
      name: "Shirin Farahani",
      place: "Shiraz · Iran",
      ward: "Reader of the Poet's Oracle",
      em: '<g fill="none" stroke="url(#gold)" stroke-width="3"><rect x="34" y="34" width="32" height="32"/><rect x="34" y="34" width="32" height="32" transform="rotate(45 50 50)"/></g>',
      lore: "<em>Shirin sees the unseen and shapes new realities. The cosmos is hers, and she can touch the future.</em> She has mastered the five hidden sciences the old masters summed up as “all of it is mystery”: alchemy, astral talismans, the binding of spirits, the letter-magic that reshapes reality, and the art of illusion. At the Tomb of Hafez she reads fal, taking the poet's verses as oracle, and she casts raml figures in sand. As a charm-writer she inscribes amulets of verse, planetary seals and magic squares that turn aside the Evil Eye or bind two hearts together."
    },
    {
      rn: "X",
      name: "Ren Hoshino",
      place: "Kyoto · Japan",
      ward: "Onmyōji of the Old Capital",
      em: '<g fill="none" stroke="url(#gold)" stroke-width="3" stroke-linejoin="round"><path d="M50 26 L64 69 L27 42 L73 42 L36 69 Z"/></g>',
      lore: "<em>Ren is a philosopher who speaks with spirits. He has studied the dark arts so he can break their curses.</em> He follows Onmyōdō, the Way of Yin and Yang practised by Kyoto's court diviners since the Heian age. Trained in the methods of Abe no Seimei, he reads omens, seals homes against misfortune and sends out paper shikigami as guardians. The mountain discipline of Shugendō gave him command of fire and weather, and esoteric Buddhism the hand seals that cut through evil. He knows Kyoto's shadow rites too, the Hour of the Ox curse among them, which is how he knows to undo them."
    }
  ];

  window.HH_SEVEN = SEVEN;

  function generatePlateSVG(w, idx) {
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 380" width="100%" height="100%">
      <defs>
        <linearGradient id="pg_${idx}" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#2a3c6b"/><stop offset="1" stop-color="#111228"/></linearGradient>
        <linearGradient id="pgg_${idx}" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#f6e2a6"/><stop offset=".5" stop-color="#c9a35a"/><stop offset="1" stop-color="#8f6d34"/></linearGradient>
      </defs>
      <rect width="300" height="380" rx="8" fill="url(#pg_${idx})"/>
      <rect x="10" y="10" width="280" height="360" rx="6" fill="none" stroke="url(#pgg_${idx})" stroke-width="1.5" opacity="0.6"/>
      <rect x="16" y="16" width="268" height="348" rx="4" fill="none" stroke="url(#pgg_${idx})" stroke-width="0.75" stroke-dasharray="3 4" opacity="0.4"/>
      <circle cx="150" cy="140" r="70" fill="#181b38" stroke="url(#pgg_${idx})" stroke-width="2"/>
      <circle cx="150" cy="140" r="62" fill="none" stroke="url(#pgg_${idx})" stroke-width="0.8" stroke-dasharray="2 3"/>
      <g transform="translate(100, 90) scale(1)">${w.em.replace(/url\(#gold\)/g, `url(#pgg_${idx})`)}</g>
      <text x="150" y="240" font-family="'Cinzel Decorative', serif" font-size="16" font-weight="bold" fill="url(#pgg_${idx})" text-anchor="middle" letter-spacing="3">${w.rn}</text>
      <text x="150" y="270" font-family="'Cinzel Decorative', serif" font-size="18" font-weight="bold" fill="#f6e2a6" text-anchor="middle">${w.name}</text>
      <text x="150" y="295" font-family="'Marcellus', serif" font-size="12" fill="#c9a35a" text-anchor="middle" letter-spacing="1">${w.place}</text>
      <text x="150" y="325" font-family="'Cormorant Garamond', serif" font-style="italic" font-size="13" fill="#e5e4ec" text-anchor="middle" opacity="0.85">${w.ward}</text>
    </svg>`;
    return 'data:image/svg+xml;utf8,' + encodeURIComponent(svg);
  }

  const WITCHIMG = SEVEN.map((w, i) => generatePlateSVG(w, i));
  window.HH_WITCHIMG = WITCHIMG;

  function initPlatesSection() {
    const platesContainer = document.getElementById('plates') || document.querySelector('.hh-plates');
    const castImg = document.getElementById('castImg') || document.getElementById('hhCastImg');
    if (castImg && !castImg.getAttribute('src') && !castImg.dataset.customImage) {
      castImg.src = WITCHIMG[1];
    }

    // Populate fallback images if Liquid plates have no custom/featured product image yet
    document.querySelectorAll('.hh-plateimg-fallback').forEach(img => {
      const idx = parseInt(img.dataset.fallbackIndex, 10);
      if (!isNaN(idx) && WITCHIMG[idx]) {
        img.src = WITCHIMG[idx];
        if (window.hhPlatesData && window.hhPlatesData[idx] && !window.hhPlatesData[idx].img) {
          window.hhPlatesData[idx].img = WITCHIMG[idx];
        }
      }
    });

    if (platesContainer && platesContainer.children.length === 0) {
      platesContainer.innerHTML = SEVEN.map((w, i) => `
        <div class="hh-plate hh-reveal" onclick="window.hhOpenPlate(${i})" data-plate-index="${i}">
          <img class="hh-plateimg" src="${WITCHIMG[i]}" alt="${w.name}">
          <div class="rn">${w.rn}</div>
          <h3>${w.name}</h3>
          <div class="place">${w.place}</div>
          <div class="ward">${w.ward}</div>
          <div class="view"><span>Read the keeper →</span></div>
        </div>
      `).join("");
    }
  }

  /* ---------- Modal For Single Witch Plate ---------- */
  window.hhOpenPlate = function (i) {
    const w = (window.hhPlatesData && window.hhPlatesData[i]) ? window.hhPlatesData[i] : SEVEN[i];
    if (!w) return;

    // Locate modal (scoped section modal, #modal, or #hhModal)
    let modal = document.querySelector('[id^="hh-coven-modal-"]') || document.getElementById('modal') || document.getElementById('hhModal') || document.querySelector('.hh-modal');
    const modalCard = modal ? (modal.querySelector('.hh-modal-card') || document.getElementById('modalCard') || document.getElementById('hhModalCard')) : null;
    if (!modal || !modalCard) return;

    const imgSrc = w.img || (WITCHIMG && WITCHIMG[i]) || '';
    const priceText = w.price ? (w.priceLabel ? `${w.priceLabel} · ${w.price}` : w.price) : 'Grimoire plate · $7.99';
    const isAvail = w.available !== false;
    const btnLabel = isAvail ? (w.buttonText || 'Add this plate') : 'Sold Out';
    const disabledAttr = isAvail ? '' : 'disabled';

    modalCard.innerHTML = `
      <button class="x" onclick="window.hhClosePlate()" aria-label="Close">✕</button>
      ${imgSrc ? `<img class="hh-modalimg" src="${imgSrc}" alt="${w.name || ''}">` : ''}
      <div class="rn">${w.rn || ''}</div>
      <h3>${w.name || ''}</h3>
      ${w.place ? `<div class="place">${w.place}</div>` : ''}
      ${w.ward ? `<div class="ward">${w.ward}</div>` : ''}
      <div class="lore">${w.lore || ''}</div>
      <div class="collect">
        <span class="pr">${priceText}</span>
        <button type="button" class="hh-btn solid" onclick="window.hhAddPlate(${i})" ${disabledAttr}>${btnLabel}</button>
      </div>
    `;
    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
  };

  window.hhClosePlate = function () {
    const modals = document.querySelectorAll('.hh-modal.open, [id^="hh-coven-modal-"].open, #modal.open, #hhModal.open');
    modals.forEach(m => m.classList.remove('open'));
    document.body.style.overflow = '';
  };

  /* ---------- Toast Notification ---------- */
  let toastTimer;
  window.hhToast = function (msg) {
    let toastEl = document.getElementById('toast') || document.getElementById('hhToast');
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.id = 'hhToast';
      toastEl.className = 'hh-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.style.opacity = '1';
    toastEl.style.transform = 'translateX(-50%) translateY(0)';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      toastEl.style.opacity = '0';
      toastEl.style.transform = 'translateX(-50%) translateY(20px)';
    }, 3500);
  };

  /* ---------- Moon Phase Calculator & SVG Renderer ---------- */
  function moonSVG(i, size) {
    const g = "#c9a35a", n = "#1b2140", r = "#9a7638";
    const base = `<circle cx="14" cy="14" r="12" fill="${n}" stroke="${r}" stroke-width="1"/>`;
    const gc = `<circle cx="14" cy="14" r="12" fill="${g}" stroke="${r}" stroke-width="1"/>`;
    const p = [
      base,
      base + `<path d="M14 2 A12 12 0 0 1 14 26 A6 12 0 0 0 14 2 Z" fill="${g}"/>`,
      base + `<path d="M14 2 A12 12 0 0 1 14 26 Z" fill="${g}"/>`,
      gc + `<path d="M14 2 A12 12 0 0 0 14 26 A6 12 0 0 1 14 2 Z" fill="${n}"/>`,
      gc,
      gc + `<path d="M14 2 A12 12 0 0 1 14 26 A6 12 0 0 0 14 2 Z" fill="${n}"/>`,
      base + `<path d="M14 2 A12 12 0 0 0 14 26 Z" fill="${g}"/>`,
      base + `<path d="M14 2 A12 12 0 0 0 14 26 A6 12 0 0 1 14 2 Z" fill="${g}"/>`
    ];
    return `<svg viewBox="0 0 28 28" style="width:${size || 34}px;height:${size || 34}px">${p[i]}</svg>`;
  }

  const MOONNAME = ["the new moon", "the waxing crescent", "the first quarter", "the waxing gibbous", "the full moon", "the waning gibbous", "the last quarter", "the waning crescent"];
  
  function moonPhase(d) {
    if (!d) return 1;
    const t = new Date(d);
    if (isNaN(t)) return 1;
    const known = Date.UTC(2000, 0, 6, 18, 14);
    let x = ((t.getTime() - known) / 86400000) % 29.53059;
    if (x < 0) x += 29.53059;
    return Math.round(x / 29.53059 * 8) % 8;
  }

  /* ---------- Archetypes Mapping ---------- */
  const ARCH = {
    // New Archetypes
    mother: { name: "The Mother", god: "Demeter", stone: "Emerald", em: "em-creatrix", inc: "I hold what is precious; my roots run deep and my love does not break." },
    maiden: { name: "The Maiden", god: "Persephone", stone: "Aquamarine", em: "em-oracle", inc: "I step into the dawn unwounded; all possibilities belong to me." },
    queen: { name: "The Queen", god: "Hera", stone: "Ruby", em: "em-crone", inc: "I claim my sovereign crown; I govern my peace and rule my own life." },
    huntress: { name: "The Huntress", god: "Artemis", stone: "Moonstone", em: "em-huntress", inc: "I hunt my own horizon; the dark does not frighten what the moon has blessed." },
    sage: { name: "The Sage", god: "Athena", stone: "Sapphire", em: "em-oracle", inc: "I see beyond the veil; knowledge is my sanctuary and truth my guide." },
    mystic: { name: "The Mystic", god: "Hecate", stone: "Labradorite", em: "em-wild", inc: "I listen to the unseen whispers; the cosmos speaks through my stillness." },
    lover: { name: "The Lover", god: "Aphrodite", stone: "Rose quartz", em: "em-lover", inc: "Nothing is sweeter than desire — and I am allowed to want." },
    none: { name: "The Unbound Spirit", god: "The Elements", stone: "Clear Quartz", em: "em-oracle", inc: "I am bound by no single title; the winds and stars know my name." },

    // Backward compatibility for existing cards & deep links
    oracle: { name: "The Oracle", god: "Athena", stone: "Labradorite", em: "em-oracle", inc: "I light my own lamp; I do not wait for dawn." },
    wild: { name: "The Wild Woman", god: "Lilith", stone: "Carnelian", em: "em-wild", inc: "I would rather be wild and my own than tame and someone else's." },
    crone: { name: "The Crone", god: "Hecate", stone: "Obsidian", em: "em-crone", inc: "I stand at the crossroads and fear no road — I have walked them all." },
    creatrix: { name: "The Creatrix", god: "The Muses", stone: "Citrine", em: "em-creatrix", inc: "I make worlds before breakfast. Watch me." }
  };

  const INTENT2ARCH = {
    "Hype her up": "huntress",
    "Comfort her": "lover",
    "Celebrate her": "creatrix",
    "Lovingly roast her": "wild",
    "Steel her for what's coming": "crone",
    "Ground & affirm her": "sage",
    "Hype them up": "huntress",
    "Comfort them": "lover",
    "Celebrate them": "creatrix",
    "Lovingly roast them": "wild",
    "Steel them for what's coming": "crone",
    "Ground & affirm them": "sage",
    "Hype me up": "huntress",
    "Comfort me": "lover",
    "Celebrate me": "creatrix",
    "Lovingly roast me": "wild",
    "Steel me for what's coming": "crone",
    "Ground & affirm me": "sage"
  };

  const ELEMHUE = {
    Earth: "the deep green",
    Air: "the clear indigo",
    Fire: "the ember red",
    Water: "the tide-teal"
  };

  const WITCH_OPTIONS = [
    { value: "Generic - None Selected", name: "Generic - None Selected", rawName: "Generic - None Selected", ward: "The Keepers of the Hexes", imgIdx: 1 },
    { value: "Anselm Voght (Black Forest)", name: "Anselm Voght (Black Forest)", rawName: "Anselm Vogt", ward: "The Green Watch of the Black Forest", imgIdx: 0 },
    { value: "Fiona MacBride (Scottish Highlands)", name: "Fiona MacBride (Scottish Highlands)", rawName: "Fiona MacBride", ward: "Keeper of the Standing Stones", imgIdx: 1 },
    { value: "Rowan Ellison (Salem)", name: "Rowan Ellison (Salem)", rawName: "Rowan Ellison", ward: "Keeper of the Wary Flame", imgIdx: 2 },
    { value: "Nuria Castro (Galicia Spain)", name: "Nuria Castro (Galicia Spain)", rawName: "Nuria Castro", ward: "Fire-Witch of the Atlantic Coast", imgIdx: 3 },
    { value: "Daciana Petran (Bucharest, Romania)", name: "Daciana Petran (Bucharest, Romania)", rawName: "Daciana Petran", ward: "Stormcaller of Wallachia", imgIdx: 4 },
    { value: "Elias Mercado (Siquijor, Philippines)", name: "Elias Mercado (Siquijor, Philippines)", rawName: "Elias Mercado", ward: "Mananambal of the Healing Isle", imgIdx: 5 },
    { value: "Thabo Nkosi (South Africa)", name: "Thabo Nkosi (South Africa)", rawName: "Thabo Nkosi", ward: "Diviner of the Green Hills", imgIdx: 6 },
    { value: "Maryam Al-Kathiri (Oman)", name: "Maryam Al-Kathiri (Oman)", rawName: "Maryam Al-Kathiri", ward: "Letter-Keeper of the City of Jinn", imgIdx: 7 },
    { value: "Shirin Farahani (Shiraz, Iran)", name: "Shirin Farahani (Shiraz, Iran)", rawName: "Shirin Farahani", ward: "Reader of the Poet's Oracle", imgIdx: 8 },
    { value: "Ren Hoshino (Kyoto, Japan)", name: "Ren Hoshino (Kyoto, Japan)", rawName: "Ren Hoshino", ward: "Onmyōji of the Old Capital", imgIdx: 9 }
  ];

  /* ---------- Hex Flow / Quiz Overlay Wizard ---------- */
  let HX = {}, STEPS = [], CUR = 0;

  window.openHex = function (t, pre) {
    HX = Object.assign({}, pre || {});
    HX._pre = Object.keys(pre || {});
    if (typeof t === 'string' && t) HX._tier = t;

    // Map intent to archetype if intent was pre-populated
    if (pre && pre.intent && !HX.archetype) {
      HX.archetype = INTENT2ARCH[pre.intent] || 'none';
    }

    const overlay = document.getElementById('overlay') || document.getElementById('hhOverlay');
    if (overlay) {
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      renderPath();
    }
  };

  window.closeHex = function () {
    const overlay = document.getElementById('overlay') || document.getElementById('hhOverlay');
    const prog = document.getElementById('prog') || document.getElementById('hhProg');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
    if (prog) prog.style.width = '0';
  };

  const BASE = [
    {
      t: 'chips',
      key: 'witch',
      q: 'Choose your witch',
      sub: 'they will speak the incantation for you',
      opts: WITCH_OPTIONS.map(w => w.name)
    },
    {
      t: 'choice',
      key: 'forWho',
      q: 'Who is this hex for?',
      opts: ['Myself', 'Someone I know well', 'Someone I don\'t know that well']
    },
    {
      t: 'fields',
      key: 'requester',
      q: 'Incantation Requester',
      sub: 'who is asking the spirits for this blessing?',
      fields: [
        { key: 'requester', label: 'Requester name or relationship', ph: 'e.g. Heather, a sister, a friend', max: 80, counter: true }
      ]
    },
    {
      t: 'fields',
      key: 'origins',
      q: 'The name & origins to bless',
      sub: 'the soul to be named on the sacred parchment',
      fields: [
        { key: 'name', label: 'Their name', ph: 'Delphine', req: 1, max: 80, counter: true },
        { key: 'birth', label: 'Their birth date', type: 'date' },
        { key: 'birthplace', label: 'Birthplace', ph: 'e.g. Edinburgh, Scotland', max: 80, counter: true },
        { key: 'residence', label: 'Current Residence', ph: 'e.g. Austin, Texas', max: 80, counter: true }
      ]
    },
    {
      t: 'chips',
      key: 'occasion',
      q: 'The occasion',
      sub: 'the threshold they stand before',
      opts: ['A Special Home', 'Wedding', 'Baby shower', 'Graduation', 'New job', 'Birthday', 'Fresh start', 'Divorce', 'Breakup', 'Just because', 'For Them']
    },
    {
      t: 'chips',
      key: 'archetype',
      q: 'Their Archetype',
      sub: 'choose the archetype that mirrors their true spirit',
      opts: ['None selected', 'Mother', 'Maiden', 'Queen', 'Huntress', 'Sage', 'Mystic', 'Lover']
    },
    {
      t: 'chips',
      key: 'intent',
      q: 'What should this hex do?',
      sub: 'the feeling and frequency to cast into the words',
      opts: ['Hype them up', 'Comfort them', 'Celebrate them', 'Lovingly roast them', 'Steel them for what\'s coming', 'Ground & affirm them']
    },
    {
      t: 'chips',
      key: 'element',
      q: 'Their element or shade',
      sub: 'keys their colour, their stone, their season',
      opts: ['Earth', 'Air', 'Fire', 'Water'],
      skip: 1
    },
    {
      t: 'three',
      key: 'three',
      q: 'Them, in three words',
      sub: 'three words to weave into their incantation',
      fields: ['w1', 'w2', 'w3']
    },
    {
      t: 'fields',
      key: 'lifeChar',
      q: 'Life and Character',
      sub: 'who they are, what they carry, what makes them laugh, fight, or believe',
      fields: [
        { key: 'lifeChar', label: 'Life and Character', type: 'area', ph: 'tell us about their spirit, personality, what they have walked through…', req: 1, max: 1000, counter: true }
      ]
    },
    {
      t: 'fields',
      key: 'objective',
      q: 'Incantation Objective',
      sub: 'what do you want this incantation to bring about?',
      fields: [
        { key: 'objective', label: 'Incantation Objective', type: 'area', ph: 'courage · nerve · deep healing · radiant joy · a door opening…', req: 1, max: 1200, counter: true }
      ]
    }
  ];

  const QUICK = [
    {
      t: 'fields',
      key: 'quickline',
      q: 'In a line or two',
      sub: 'who are they right now?',
      fields: [
        { key: 'quickline', type: 'area', ph: 'walking into, walking away from, or celebrating…' }
      ]
    }
  ];

  const DEEP = [
    {
      t: 'deep',
      key: 'deep',
      q: 'To be seen — up to seven',
      sub: 'a phrase each; fill as many as ring true',
      fields: [
        ['proud', 'Something they are quietly proud of'],
        ['reach', 'The beautiful thing they are reaching for'],
        ['between', 'What stands between them and it'],
        ['said', 'The best thing anyone ever said about them'],
        ['unkind', 'Where life has been unkind lately'],
        ['detail', 'The unmistakable detail — a nickname, a quirk'],
        ['child', 'A childhood moment they would never lose']
      ]
    }
  ];

  function renderPath() {
    const prog = document.getElementById('prog') || document.getElementById('hhProg');
    const stage = document.getElementById('stage') || document.getElementById('hhStage');
    if (prog) prog.style.width = '6%';
    if (stage) {
      stage.innerHTML = `
        
        <p class="hh-q-eyebrow">Incantation Creation</p>
        <h2 class="hh-q-title">Choose your path</h2>
        <p class="hh-q-sub">The same spell, cast quick or cast deep.</p>
        <div class="hh-opts">
          <button type="button" class="hh-opt" onclick="window.hhStartFlow('quick')">
            <b style="font-family:var(--hh-disp);color:var(--hh-gold);font-size:21px">The Quick Path</b><br>
            <span style="color:var(--hh-body-dim)">Guided steps and prompts — for the impulse and the gift.</span>
          </button>
          <button type="button" class="hh-opt" onclick="window.hhStartFlow('deep')">
            <b style="font-family:var(--hh-disp);color:var(--hh-gold);font-size:21px">The Deep Path</b><br>
            <span style="color:var(--hh-body-dim)">Full questions and character prompts — for the one you want seen all the way down.</span>
          </button>
        </div>
      `;
    }
  }

  function buildSteps(path) {
    const isMyself = (HX.forWho === 'Myself');
    return BASE.concat(path === 'quick' ? QUICK : DEEP).filter(s => {
      if (s.key && (HX._pre || []).includes(s.key)) return false;
      if (isMyself && s.key === 'requester') return false;
      return true;
    });
  }

  function resolveStep(rawStep) {
    if (!rawStep) return rawStep;
    const isMyself = (HX.forWho === 'Myself');
    if (!isMyself) return rawStep;

    const s = JSON.parse(JSON.stringify(rawStep));

    if (s.key === 'origins') {
      s.q = 'Your name & origins to bless';
      s.sub = 'your name on the sacred parchment';
      if (s.fields) {
        s.fields = s.fields.map(f => {
          if (f.key === 'name') return { ...f, label: 'Your name', ph: 'Your name' };
          if (f.key === 'birth') return { ...f, label: 'Your birth date' };
          if (f.key === 'birthplace') return { ...f, label: 'Your birthplace' };
          return f;
        });
      }
    } else if (s.key === 'occasion') {
      s.sub = 'the threshold you stand before';
      if (s.opts) {
        s.opts = s.opts.map(o => (o === 'For Them' ? 'For Myself' : o));
      }
    } else if (s.key === 'archetype') {
      s.q = 'Your Archetype';
      s.sub = 'choose the archetype that mirrors your true spirit';
    } else if (s.key === 'intent') {
      s.opts = [
        'Hype me up',
        'Comfort me',
        'Celebrate me',
        'Lovingly roast me',
        'Steel me for what\'s coming',
        'Ground & affirm me'
      ];
    } else if (s.key === 'element') {
      s.q = 'Your element or shade';
      s.sub = 'keys your colour, your stone, your season';
    } else if (s.key === 'three' || s.t === 'three') {
      s.q = 'You, in three words';
      s.sub = 'three words to weave into your incantation';
    } else if (s.key === 'lifeChar') {
      s.sub = 'who you are, what you carry, what makes you laugh, fight, or believe';
      if (s.fields) {
        s.fields = s.fields.map(f => {
          if (f.key === 'lifeChar') {
            return { ...f, ph: 'tell us about your spirit, personality, what you have walked through…' };
          }
          return f;
        });
      }
    } else if (s.key === 'quickline') {
      s.sub = 'who are you right now?';
      if (s.fields) {
        s.fields = s.fields.map(f => {
          if (f.key === 'quickline') {
            return { ...f, ph: 'what you are walking into, walking away from, or celebrating…' };
          }
          return f;
        });
      }
    } else if (s.key === 'deep' || s.t === 'deep') {
      if (Array.isArray(s.fields)) {
        s.fields = s.fields.map(([k, label]) => {
          let l = label;
          if (k === 'proud') l = 'Something you are quietly proud of';
          else if (k === 'reach') l = 'The beautiful thing you are reaching for';
          else if (k === 'between') l = 'What stands between you and it';
          else if (k === 'said') l = 'The best thing anyone ever said about you';
          else if (k === 'child') l = 'A childhood moment you would never lose';
          return [k, l];
        });
      }
    }

    return s;
  }

  window.hhStartFlow = function (path) {
    HX._path = path;
    STEPS = buildSteps(path);
    CUR = 0;
    renderStep();
  };

  window.hhGo = function (n) {
    CUR = n;
    if (CUR >= STEPS.length) {
      renderResult();
    } else {
      renderStep();
    }
  };

  function renderStep() {
    const prog = document.getElementById('prog') || document.getElementById('hhProg');
    const stage = document.getElementById('stage') || document.getElementById('hhStage');
    if (!stage) return;
    const s = resolveStep(STEPS[CUR]);
    if (!s) {
      renderResult();
      return;
    }
    if (prog) prog.style.width = (8 + (CUR / (STEPS.length)) * 84) + '%';
    let body = '';

    if (s.t === 'choice') {
      body = `<div class="hh-opts">` + s.opts.map(o => `<button type="button" class="hh-opt ${HX[s.key] === o ? 'sel' : ''}" onclick="window.hhPick('${s.key}',this,${CUR})">${o}</button>`).join('') + `</div>`;
    } else if (s.t === 'chips') {
      body = `<div class="chips">` + s.opts.map(o => `<button type="button" class="chip ${HX[s.key] === o ? 'sel' : ''}" onclick="window.hhPick('${s.key}',this,${CUR})">${o}</button>`).join('') + `</div>`;
    } else if (s.t === 'three') {
      body = `<div class="hh-three">` + s.fields.map((k, j) => `<div class="hh-field"><input id="f_${k}" placeholder="${['fierce', 'tender', 'unstoppable'][j]}" value="${HX[k] || ''}"></div>`).join('') + `</div>`;
    } else if (s.t === 'deep') {
      body = `<div class="hh-fields">` + s.fields.map(([k, l]) => `<div class="hh-field"><label>${l}</label><input id="f_${k}" value="${HX[k] || ''}"></div>`).join('') + `</div>`;
    } else {
      body = `<div class="hh-fields">` + s.fields.map(f => `
        <div class="hh-field">
          <div class="hh-label-row">
            ${f.label ? `<label for="f_${f.key}">${f.label} ${f.req ? '<span class="hh-req">*</span>' : ''}</label>` : ''}
            ${f.counter ? `<span class="hh-counter" id="cnt_${f.key}">0 / ${f.max}</span>` : ''}
          </div>
          ${f.type === 'area'
            ? `<textarea id="f_${f.key}" ${f.max ? `maxlength="${f.max}"` : ''} placeholder="${f.ph || ''}">${HX[f.key] || ''}</textarea>`
            : `<input id="f_${f.key}" type="${f.type || 'text'}" ${f.max ? `maxlength="${f.max}"` : ''} placeholder="${f.ph || ''}" value="${HX[f.key] || ''}">`
          }
        </div>
      `).join('') + `</div>`;
    }

    const showNext = s.t !== 'choice' && s.t !== 'chips';
    stage.innerHTML = `
      
      <p class="hh-q-eyebrow">Step ${CUR + 1} of ${STEPS.length}</p>
      <h2 class="hh-q-title">${s.q}</h2>
      ${s.sub ? `<p class="hh-q-sub">${s.sub}</p>` : ''}
      ${body}
      <div class="hh-flownav">
        <button type="button" class="hh-ghost" onclick="${CUR === 0 ? 'window.hhRenderPath()' : 'window.hhGo(' + (CUR - 1) + ')'}">← Back</button>
        <div>
          ${s.skip ? `<button type="button" class="hh-ghost" style="margin-right:10px" onclick="window.hhGo(${CUR + 1})">Skip</button>` : ''}
          ${showNext ? `<button type="button" class="hh-btn solid" onclick="window.hhSaveNext(${CUR})">${CUR === STEPS.length - 1 ? 'Create incantation ✦' : 'Next →'}</button>` : ''}
        </div>
      </div>
    `;

    // Attach char counter listeners for fields in this step
    if (s.fields && Array.isArray(s.fields)) {
      s.fields.forEach(f => {
        if (f.counter && f.max) {
          const inp = document.getElementById('f_' + f.key);
          const cnt = document.getElementById('cnt_' + f.key);
          if (inp && cnt) {
            cnt.textContent = `${inp.value.length} / ${f.max}`;
            inp.addEventListener('input', () => {
              cnt.textContent = `${inp.value.length} / ${f.max}`;
              if (inp.value.length >= f.max) cnt.classList.add('at-limit');
              else cnt.classList.remove('at-limit');
            });
          }
        }
      });
    }
  }

  window.hhRenderPath = renderPath;

  window.hhPick = function (key, el, i) {
    HX[key] = el.textContent.trim();
    if (key === 'forWho') {
      if (HX.forWho === 'Myself') {
        HX.requester = 'Myself';
      } else if (HX.requester === 'Myself') {
        HX.requester = '';
      }
      STEPS = buildSteps(HX._path || 'quick');
    }
    window.hhGo(i + 1);
  };

  window.hhSaveNext = function (i) {
    const s = resolveStep(STEPS[i]);
    const read = (k) => {
      const el = document.getElementById('f_' + k);
      return el ? el.value.trim() : '';
    };

    if (s.t === 'three') {
      s.fields.forEach(k => HX[k] = read(k));
    } else if (s.t === 'deep') {
      s.fields.forEach(([k]) => HX[k] = read(k));
    } else if (s.fields) {
      for (const f of s.fields) {
        HX[f.key] = read(f.key);
        if (f.req && !HX[f.key]) {
          const el = document.getElementById('f_' + f.key);
          if (el) {
            el.style.borderColor = 'var(--hh-rose)';
            el.focus();
          }
          hhToast('✦ Please complete the required field.');
          return;
        }
      }
    }
    window.hhGo(i + 1);
  };

  function renderResult() {
    const prog = document.getElementById('prog') || document.getElementById('hhProg');
    const stage = document.getElementById('stage') || document.getElementById('hhStage');
    if (prog) prog.style.width = '100%';

    // Sync legacy/new keys
    if (HX.lifeChar && !HX.stands) HX.stands = HX.lifeChar;
    if (HX.stands && !HX.lifeChar) HX.lifeChar = HX.stands;
    if (HX.objective && !HX.wish) HX.wish = HX.objective;
    if (HX.wish && !HX.objective) HX.objective = HX.wish;

    // Archetype resolution
    let archKey = 'none';
    if (HX.archetype) {
      const clean = HX.archetype.toLowerCase().trim();
      if (ARCH[clean]) archKey = clean;
    }
    if (archKey === 'none' && HX.intent && INTENT2ARCH[HX.intent]) {
      archKey = INTENT2ARCH[HX.intent];
    }
    const a = ARCH[archKey] || ARCH.mother || ARCH.oracle;
    const ph = moonPhase(HX.birth);
    const hue = ELEMHUE[HX.element] || 'the returning light';
    const words = [HX.w1, HX.w2, HX.w3].filter(Boolean).join(', ');

    // Witch resolution for scroll plate
    const selectedWitchObj = WITCH_OPTIONS.find(w => w.value === HX.witch || w.name === HX.witch) || WITCH_OPTIONS[0];
    const hitWitch = SEVEN.find(w => w.name === selectedWitchObj.rawName || (HX.witch && HX.witch.includes(w.name)));
    const witchImg = (hitWitch && WITCHIMG[SEVEN.indexOf(hitWitch)]) ? WITCHIMG[SEVEN.indexOf(hitWitch)] : (WITCHIMG[1] || '');

    // Live update preview scroll on page
    const parchFor = document.getElementById('parchFor');
    if (parchFor && HX.name) {
      parchFor.textContent = `For ${HX.name}`;
      parchFor.style.display = '';
    }
    const parchArch = document.getElementById('parchArch');
    if (parchArch) parchArch.textContent = a.name.toUpperCase();
    const parchInc = document.getElementById('parchInc');
    if (parchInc) parchInc.innerHTML = a.inc;
    const parchAttr = document.getElementById('parchAttr');
    if (parchAttr) parchAttr.textContent = `— the voice of ${a.name}`;
    const parchGrace = document.getElementById('parchGrace');
    if (parchGrace) parchGrace.innerHTML = `your goddess · ${a.god}&nbsp;&nbsp;·&nbsp;&nbsp;your stone · ${a.stone}&nbsp;&nbsp;·&nbsp;&nbsp;your season · ${hue}`;

    const parchCastName = document.getElementById('parchCastName');
    if (parchCastName) {
      parchCastName.textContent = hitWitch ? hitWitch.name : selectedWitchObj.name;
    }
    const parchCastWard = document.getElementById('parchCastWard');
    if (parchCastWard) {
      parchCastWard.textContent = hitWitch ? hitWitch.ward : selectedWitchObj.ward;
    }
    const ci = document.getElementById('castImg') || document.getElementById('hhCastImg');
    if (ci && witchImg) {
      ci.src = witchImg;
    }

    const isMyself = (HX.forWho === 'Myself');

    if (stage) {
      stage.innerHTML = `
        <div class="hh-result">
          
          <p class="named">${isMyself ? 'The spirits name you' : 'The spirits name them'}</p>
          <h2>${a.name}</h2>
          <svg class="hh-rcoin" viewBox="0 0 200 200">
            <use href="#coinframe"/>
            <g filter="url(#inkSoft)"><use href="#${a.em}"/></g>
          </svg>
          <div class="hh-rinc">&ldquo;${a.inc}&rdquo;</div>
          <div class="hh-rfor">${HX.name ? ('an incantation for ' + HX.name) : (isMyself ? 'an incantation for you' : 'an incantation, cast')}${words ? (' — ' + words) : ''}${HX.birthplace ? (' · born in ' + HX.birthplace) : ''}</div>
          <div class="hh-rmoon">${moonSVG(ph, 30)}<span>your lucky phase — ${MOONNAME[ph]}</span></div>
          <div class="hh-rgrace">your goddess · ${a.god}&nbsp;&nbsp;·&nbsp;&nbsp;your stone · ${a.stone}&nbsp;&nbsp;·&nbsp;&nbsp;your season · ${hue}</div>
          
          <div class="hh-meta-row" style="justify-content:center;margin: 18px 0 22px 0;">
            <div class="hh-length-badge">
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
                <line x1="16" y1="13" x2="8" y2="13"/>
                <line x1="16" y1="17" x2="8" y2="17"/>
              </svg>
              <span>Incantation length: <strong>200 words</strong></span>
            </div>
          </div>

          <div class="hh-rcta">
            ${hhTierButtons()}
          </div>
          <button type="button" class="hh-ghost" style="margin-top:16px;" onclick="window.hhStartFlow(HX._path || 'quick')">← Edit details</button>
          <p style="color:var(--hh-body-dim);font-size:13.5px;margin-top:20px;font-style:italic">Press Cast to add ${isMyself ? 'your' : 'their'} incantation to your cart. ${isMyself ? 'Your' : 'Their'} full incantation (200 words), ritual and scroll are consecrated once your order is in.</p>
        </div>
      `;
    }
  }

  const HH_TIERS = [
    // { k: 'digital', label: 'Digital Scroll', price: '$6.49' },
    { k: 'printed', label: 'Printed Scroll', price: '$18.99' },
    { k: 'reliquary', label: 'The Reliquary', price: '$35.99' }
  ];

  function hhTierButtons() {
    return '<div class="hh-tiers" style="display:flex;flex-wrap:wrap;gap:12px;justify-content:center">' + HH_TIERS.map(t => `
      <button type="button" class="hh-btn ${HX._tier === t.k ? 'solid' : ''}" onclick="window.hhCast('${t.k}')">
        Cast · ${t.label} · ${t.price}
      </button>
    `).join('') + '</div>';
  }

  /* ---------- Add To Cart / Checkout Handlers with Shopify AJAX API ---------- */
  window.hhCast = function (k) {
    const tier = HH_TIERS.find(t => t.k === k) || HH_TIERS[0];
    let archKey = 'none';
    if (HX.archetype) {
      const clean = HX.archetype.toLowerCase().trim();
      if (ARCH[clean]) archKey = clean;
    }
    if (archKey === 'none' && HX.intent && INTENT2ARCH[HX.intent]) {
      archKey = INTENT2ARCH[HX.intent];
    }
    const a = ARCH[archKey] || ARCH.mother || ARCH.oracle;
    const ph = moonPhase(HX.birth);
    const hue = ELEMHUE[HX.element] || 'the returning light';

    const isMyself = (HX.forWho === 'Myself');

    // Comprehensive Order Properties for Shopify Admin & Owner
    const itemProperties = {
      'Recipient Name': HX.name || (isMyself ? 'Myself' : 'Them'),
      'Birthdate': HX.birth || 'Not specified',
      'Birthplace': HX.birthplace || 'Not specified',
      'Incantation Requester': HX.requester || (isMyself ? 'Myself' : 'Not specified'),
      'Archetype': a.name,
      'Current Residence': HX.residence || 'Not specified',
      'Life and Character': HX.lifeChar || HX.stands || '',
      'Incantation Objective': HX.objective || HX.wish || '',
      'Witch': HX.witch || 'Generic - None Selected',
      'Incantation Length': '200 words',
      'Tier': tier.label,
      'Lucky Moon Phase': MOONNAME[ph],
      'Goddess': a.god || 'Athena',
      'Stone': a.stone || 'Labradorite',
      'Element': HX.element || 'Universal',
      'Three Words': [HX.w1, HX.w2, HX.w3].filter(Boolean).join(', ') || 'Fierce, tender, bright',
      'Occasion': HX.occasion || 'Custom Incantation',
      'Who is this for': HX.forWho || 'Not specified',
      // Legacy compatibility keys:
      'Where They Stand': HX.lifeChar || HX.stands || '',
      'Wish': HX.objective || HX.wish || '',
      'Where She Stands': HX.lifeChar || HX.stands || ''
    };

    if (HX._path === 'deep') {
      ['proud', 'reach', 'between', 'said', 'unkind', 'detail', 'child'].forEach(f => {
        if (HX[f]) itemProperties[`Deep Note (${f})`] = HX[f];
      });
    }

    const handleMap = {
      printed: 'printed-scroll',
      reliquary: 'the-reliquary',
      digital: 'digital-scroll'
    };

    function executeAddToCart(vid) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: vid,
          quantity: 1,
          properties: itemProperties
        })
      })
        .then(res => res.json())
        .then(data => {
          hhFetchCartCount();
          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: data }));
          renderCastSuccess(tier, a, HX);
        })
        .catch(() => {
          fallbackLocalCast(tier, a, itemProperties);
        });
    }

    // Try finding variant ID configured in page settings or shopify global
    const variantId = window.hhTierVariantIds && window.hhTierVariantIds[k] ? window.hhTierVariantIds[k] : null;

    if (variantId) {
      executeAddToCart(variantId);
    } else {
      const handle = handleMap[k] || 'printed-scroll';
      fetch(`/products/${handle}.js`)
        .then(res => res.json())
        .then(prod => {
          const fetchedVid = (prod && prod.variants && prod.variants.length) ? prod.variants[0].id : null;
          if (fetchedVid) {
            window.hhTierVariantIds = window.hhTierVariantIds || {};
            window.hhTierVariantIds[k] = fetchedVid;
            executeAddToCart(fetchedVid);
          } else {
            fallbackLocalCast(tier, a, itemProperties);
          }
        })
        .catch(() => {
          fallbackLocalCast(tier, a, itemProperties);
        });
    }
  };

  function fallbackLocalCast(tier, a, properties) {
    const isMyself = (HX.forWho === 'Myself');
    const recipient = HX.name || (isMyself ? 'You' : 'Them');
    const item = {
      title: `Personalized Hex (${tier.label}) for ${recipient}`,
      price: tier.price,
      quantity: 1,
      archetype: a.name,
      witch: HX.witch || 'Generic - None Selected',
      tier: tier.label,
      properties: properties
    };
    window.hhCartItems.push(item);
    hhSetCartCount(window.hhCartItems.reduce((acc, it) => acc + (it.quantity || 1), 0));
    renderCastSuccess(tier, a, HX);
  }

  /* ---------- Hex Cast Confirmation & Cart Next Steps ---------- */
  function renderCastSuccess(tier, a, hxData) {
    const stage = document.getElementById('stage') || document.getElementById('hhStage');
    const prog = document.getElementById('prog') || document.getElementById('hhProg');
    if (prog) prog.style.width = '100%';

    const isMyself = (hxData.forWho === 'Myself');
    const isBox = (tier.k === 'reliquary');
    const isDigital = (tier.k === 'digital');
    const itemType = isBox ? 'The Reliquary (Keepsake Box & Scroll)' : (isDigital ? 'Instant Digital Scroll (PDF)' : 'Hand-Finished Printed Scroll');
    const headingText = isBox ? 'The Reliquary Box Added to Your Cart' : 'Your Printed Scroll Added to Your Cart';
    const messageText = isBox
      ? `The Reliquary box has been consecrated and added to your shopping cart. You can create more hexes${isMyself ? ' for friends or loved ones' : ' for other loved ones'}, or go to the cart to check out.`
      : `Your printed scroll has been consecrated and added to your shopping cart. You can create more hexes${isMyself ? ' for friends or loved ones' : ' for other loved ones'}, or go to the cart to check out.`;

    const recipientLabel = hxData.name || (isMyself ? 'You' : 'Them');
    hhToast(`✦ Added ${tier.label} for ${recipientLabel} to your cart.`);

    if (stage) {
      stage.innerHTML = `
        <div class="hh-cast-success">
          <div class="hh-success-icon-wrap">
            <div class="hh-success-glow"></div>
            <div class="hh-success-badge">
              <svg viewBox="0 0 40 40" width="44" height="44" fill="none" aria-hidden="true">
                <circle cx="20" cy="20" r="18" stroke="var(--hh-gold)" stroke-width="1.5" stroke-dasharray="2 3"/>
                <circle cx="20" cy="20" r="14" fill="rgba(201, 163, 90, 0.12)" stroke="var(--hh-gold)" stroke-width="1.2"/>
                <polyline points="13,20 18,25 28,15" stroke="var(--hh-gold-lite)" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>

          <p class="hh-success-eyebrow">✦ CONSECRATED &amp; ADDED TO SHOPPING CART ✦</p>
          <h2 class="hh-success-title">${headingText}</h2>

          <div class="hh-success-card">
            <div class="hh-success-item-row">
              <div class="hh-success-item-info">
                <span class="hh-success-item-type">${itemType}</span>
                <span class="hh-success-item-target">${hxData.name ? ('Incantation for ' + hxData.name) : (isMyself ? 'Incantation for You' : 'Personalized Incantation')}</span>
              </div>
              <div class="hh-success-item-price">${tier.price}</div>
            </div>

            <div class="hh-success-meta-grid">
              ${(hxData.name || isMyself) ? `<div class="hh-success-meta-item"><span class="label">Recipient</span><span class="val">${hxData.name || 'Myself'}</span></div>` : ''}
              <div class="hh-success-meta-item"><span class="label">Archetype</span><span class="val">${a.name}</span></div>
              ${hxData.witch ? `<div class="hh-success-meta-item"><span class="label">Witch</span><span class="val">${hxData.witch}</span></div>` : ''}
              ${hxData.occasion ? `<div class="hh-success-meta-item"><span class="label">Occasion</span><span class="val">${hxData.occasion}</span></div>` : ''}
            </div>

            <p class="hh-success-message">
              ${messageText}
            </p>
          </div>

          <div class="hh-success-actions">
            <a href="/cart" class="hh-btn solid hh-btn-checkout" onclick="window.hhGoToCartAndClose(event)">
              <span>Go to Cart to Check Out</span>
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </a>
            <button type="button" class="hh-btn hh-btn-create-more" onclick="window.hhCreateAnotherHex()">
              <span>✦ Create More Hexes</span>
            </button>
          </div>

          <button type="button" class="hh-ghost hh-btn-continue" onclick="window.closeHex()">
            Continue Browsing
          </button>
        </div>
      `;
    }
  }

  window.hhCreateAnotherHex = function () {
    HX = {};
    CUR = 0;
    STEPS = [];
    const overlay = document.getElementById('overlay') || document.getElementById('hhOverlay');
    if (overlay) {
      overlay.classList.add('open');
      overlay.scrollTop = 0;
      document.body.style.overflow = 'hidden';
    }
    const stage = document.getElementById('stage') || document.getElementById('hhStage');
    if (stage) stage.scrollTop = 0;
    const prog = document.getElementById('prog') || document.getElementById('hhProg');
    if (prog) prog.style.width = '6%';
    renderPath();
  };

  window.hhGoToCartAndClose = function (e) {
    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    window.closeHex();
    const cartUrl = (window.MinimogSettings && window.MinimogSettings.routes && window.MinimogSettings.routes.cart)
      ? window.MinimogSettings.routes.cart
      : '/cart';
    window.location.href = cartUrl;
  };

  window.hhAddPlate = function (i) {
    const w = (window.hhPlatesData && window.hhPlatesData[i]) ? window.hhPlatesData[i] : SEVEN[i];
    if (!w) return;
    const plateVariantId = w.variantId || window.hhPlateVariantId || null;

    if (plateVariantId) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: plateVariantId,
          quantity: 1,
          properties: {
            'Grimoire Plate': `${w.rn ? w.rn + ' - ' : ''}${w.name}`,
            'Ward': w.ward || ''
          }
        })
      })
        .then(res => {
          if (!res.ok) throw new Error('Cart add failed');
          return res.json();
        })
        .then(data => {
          hhFetchCartCount();
          window.hhClosePlate();
          hhToast(`✦ Added — ${w.name}'s Grimoire Plate to cart.`);
          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: data }));
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
        })
        .catch(() => {
          fallbackPlate(w);
        });
    } else {
      fallbackPlate(w);
    }
  };

  function fallbackPlate(w) {
    window.hhCartItems.push({
      title: `${w.name}'s Grimoire Plate`,
      price: w.price || '$7.99',
      quantity: 1
    });
    hhSetCartCount(window.hhCartItems.reduce((acc, it) => acc + (it.quantity || 1), 0));
    window.hhClosePlate();
    hhToast(`✦ Added — ${w.name}'s Grimoire Plate to cart.`);
  }

  window.hhAddSet = function () {
    const setVariantId = window.hhSetVariantId || null;

    if (setVariantId) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: setVariantId,
          quantity: 1,
          properties: { 'Set': 'The Book of Ten (All 10 Grimoire Plates)' }
        })
      })
        .then(res => res.json())
        .then(data => {
          hhFetchCartCount();
          hhToast('✦ Added — the Book of Ten, all 10 plates to cart.');
          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: data }));
        })
        .catch(() => {
          fallbackSet();
        });
    } else {
      fallbackSet();
    }
  };

  function fallbackSet() {
    window.hhCartItems.push({
      title: 'The Book of Ten (Full Grimoire Plate Set)',
      price: '$59.99',
      quantity: 1
    });
    hhSetCartCount(window.hhCartItems.reduce((acc, it) => acc + (it.quantity || 1), 0));
    hhToast('✦ Added — the Book of Ten, all 10 plates to cart.');
  }

  /* ---------- Keyboard & Global Handlers ---------- */
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      window.hhClosePlate();
      window.closeHex();
    }
  });

  /* ---------- Reveal on Scroll Observer ---------- */
  function initReveal() {
    const io = new IntersectionObserver((es) => es.forEach(x => {
      if (x.isIntersecting) {
        x.target.classList.add('in');
        io.unobserve(x.target);
      }
    }), { threshold: 0.12 });

    document.querySelectorAll('.hh-reveal:not(.in), .reveal:not(.in)').forEach(el => io.observe(el));
  }

  /* ---------- Bind [data-hex] Buttons ---------- */
  function bindHexButtons() {
    document.querySelectorAll('[data-hex]').forEach(b => {
      if (!b._hhBound) {
        b._hhBound = true;
        b.addEventListener('click', (e) => {
          e.preventDefault();
          window.openHex(b.dataset.tier || '');
        });
      }
    });
  }

  /* ---------- Deep Link URL Params (?occasion=Wedding&witch=2&start=1) ---------- */
  function checkDeepLink() {
    const q = new URLSearchParams(window.location.search), pre = {};
    if (q.get('occasion')) pre.occasion = q.get('occasion');
    const w = q.get('witch');
    if (w !== null) {
      const n = parseInt(w, 10);
      const hit = isNaN(n) ? SEVEN.find(x => x.name.toLowerCase().includes(w.toLowerCase())) : SEVEN[n];
      if (hit) pre.witch = hit.name;
    }
    if (q.get('start') === '1') {
      window.openHex(q.get('tier') || '', pre);
    }
  }

  /* ---------- Main Init ---------- */
  function init() {
    initPlatesSection();
    initReveal();
    bindHexButtons();
    checkDeepLink();
    hhFetchCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify Theme Editor Reload Listeners
  document.addEventListener('shopify:section:load', () => {
    initPlatesSection();
    initReveal();
    bindHexButtons();
  });

})();
